<template>
  <div class="store-card">
    <div
      class="image-container"
      :style="{
        backgroundImage: `url(${require(`../../assets/images/stores/dots.jpg`)})`
      }"
    >
      <div class="absolute">
        <div class="logo-container">
          <img src="../../assets/images/store_logos/lumi_accessories.png" />
        </div>
        <span>46° 50’ 58.1676’’ N | 9° 31’ 50.412’’ E</span>
      </div>
    </div>
    <div class="description">
      <h5>{{ `store.${this.name}` | translate }}</h5>
      <p>
        Here would be a good place to give a quick overview about the store and
        its products.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "store-card",
  props: {
    image: String,
    logo: String,
    name: String,
    description: String,
    coordinates: String
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";

.store-card {
  min-width: 18rem;
  width: 30%;
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(0.97);
  }

  .image-container {
    position: relative;
    min-height: 18rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    &::after {
      content: "";
      position: absolute;
      background-color: $brand-gray;
      opacity: 0.3;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
    }

    .logo-container {
      height: 4rem;
      width: 4rem;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      overflow: hidden;
      margin-bottom: 0.5rem;
    }

    .absolute {
      top: 0;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      z-index: 1;

      span {
        color: $brand-white;
        font-family: "Lora";
        font-weight: 700;
        font-size: $font-sm;
      }
    }
  }

  img {
    width: 100%;
  }

  .description {
    padding-top: 1rem;

    h5 {
      font-family: "Montserrat";
      font-weight: 700;
      text-transform: capitalize;
      font-size: $font-m;
    }
  }
}
</style>
